export const VEV_EXCLUDED_STATIC_SELECTORS = [
  'articlePreHeader',
  'articleHeader',

  'lab-dz-pre-header',
  'lab-dz-header',
  'article-post-header',
];
